<template>
  <div v-if="isShowWarning && isAdmin" class="admin-account-warning">
    <div class="admin-account-warning__content">
      <div class="admin-account-warning__icon">
        <i class="material-icons admin-account-warning__icon-material">admin_panel_settings</i>
      </div>
      <div class="admin-account-warning__text">
        <span class="admin-account-warning__message"
          >You are signed in with an <strong>administrator account</strong> !<br />Use this account
          only when necessary — some features may not work correctly or may be unavailable.</span
        >
      </div>
      <button class="admin-account-warning__close" @click="closeWarning">
        <i class="material-icons admin-account-warning__close-material">close</i>
      </button>
    </div>
  </div>
</template>

<script>
  import { AuthService } from '@/services/auth.service';

  export default {
    name: 'AdminAccountWarning',

    data() {
      return {
        isShowWarning: true,
        isAdmin: false,
      };
    },

    created() {
      this.checkAdminStatus();
    },

    methods: {
      checkAdminStatus() {
        const userData = AuthService.userData();
        this.isAdmin = userData && userData.is_superuser === true;
      },

      closeWarning() {
        this.isShowWarning = false;
      },
    },
  };
</script>

<style scoped lang="scss">
  .admin-account-warning {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(135deg, $color-bg-warning, lighten($color-bg-warning, 10%));
    color: black;
    padding: 5px 20px;
    box-shadow: $shadow-light;
    z-index: 1000;

    &__content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 900px;
      margin: 0 auto;
      gap: 16px;
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background: transparentize($pure-color__white, 0.8);
      border-radius: 50%;
      flex-shrink: 0;
    }

    &__icon-material {
      font-size: 20px;
    }

    &__text {
      display: flex;
      flex-direction: column;
      gap: 2px;
      flex: 1;
      min-width: 0;
    }

    &__title {
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.5px;
    }

    &__message {
      font-size: 12px;
      opacity: 0.9;
    }

    &__close {
      background: none;
      border: none;
      color: black;
      cursor: pointer;
      padding: 8px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.2s ease;
      flex-shrink: 0;

      &:hover {
        background: transparentize($pure-color__white, 0.9);
      }
    }

    &__close-material {
      font-size: 18px;
    }

    @media (max-width: 768px) {
      padding: 10px 16px;

      &__content {
        gap: 12px;
      }

      &__icon {
        width: 32px;
        height: 32px;
      }

      &__icon-material {
        font-size: 16px;
      }

      &__title {
        font-size: 13px;
      }

      &__message {
        font-size: 11px;
      }
    }

    @media print {
      display: none;
    }
  }
</style>
